/* eslint-disable max-classes-per-file */
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Params } from "@angular/router";
import { ObjectUtils } from "../utils/object-utils";

@Injectable({
    providedIn: "root"
})
export class StatedataService {
    volatile: Volatile;
    previousParams: Params;
    currentParams: Params;

    private previousKey = "";

    updateParams(route: ActivatedRouteSnapshot) {
        this.previousParams =  this.currentParams;
        this.currentParams = { ...route.params,
            ...route.queryParams };
    }

    handleNavigation(key: string) {
        if(key === this.previousKey) {
            return;
        }

        this.previousKey = key;
        if(ObjectUtils.hasValue(this.volatile)) {
            this.volatile = new Volatile();
        }
    }

    getVolatile() {
        if (!this.volatile) {
            this.volatile = new Volatile();
        }
        return this.volatile;
    }
}

export class Volatile {
    data = {};

    get<T>(name: string) {
        return this.data[name] as T;
    }

    set(name: string, value: any) {
        this.data[name] = value;
    }
}
